import React, { useState, useEffect } from "react";
import { Col, Form, Row, Table, Input } from "antd";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import Selects from "../../../../biblio/Selects/Selects";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import {
  getSponsoredOrphans,
} from "../../../../apis/actions/sponsor.actions";
import Inputs from "../../../../biblio/Inputs/Inputs";
import MoyasarForm from "../../../../components/Moyasar/MoyasarForm";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";

import {
  resetMoyasar,
  setBeneficiaryLines,
  setDonationTypeId,
  setMobile,
} from "../../../../apis/slices/moyasarSlice";
interface Props {
  isModalVisible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddDonateToOrphansRequest = ({
  isModalVisible,
  setIsModalVisible,
}: Props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [lines, setLines] = useState<any[]>([
    { id: 1, beneficiary_id: null, amount: "", notes: "" },
  ]);
  const [isMoyasarOpen, setDisplayMoyasar] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);

  const sponsoredOrphans = useSelector(
    (state: RootState) => state.sponsor.sponsoredOrphans
  );
  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails
  );
  useEffect(() => {
    dispatch(getSponsoredOrphans({ sponsor_id: OtpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  useEffect(() => {
    updateTotalAmount();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lines]);
  const formattedOptions = sponsoredOrphans.map((orphan: any) => ({
    id: orphan.id,
    name: `${orphan.firstname} ${orphan.father_name}`,
  }));

  const updateTotalAmount = async () => {
    const total = lines.reduce(
      (sum, line) => sum + parseFloat(line.amount || "0"),
      0
    );
    setTotalAmount(total);
  };

  const addLine = () => {
    const uniqueId = new Date().getTime();
    setLines([
      ...lines,
      { id: uniqueId, beneficiary_id: null, amount: "", notes: "" },
    ]);
  };

  const removeLine = async (index: number) => {
    if (lines.length > 1) {
      const updatedLines = lines.filter((_, i) => i !== index);
      setLines(updatedLines);

      form.resetFields(
        updatedLines.map((line) => [
          `line_${line.id}_beneficiary_id`,
          `line_${line.id}_amount`,
          `line_${line.id}_notes`,
        ])
      );
      await updateTotalAmount();
    }
  };

  const handleInputChange = async (
    value: any,
    index: number,
    field: string
  ) => {
    const updatedLines = [...lines];
    updatedLines[index][field] = value;
    setLines(updatedLines);

    if (field === "amount") {
      await updateTotalAmount();
    }
  };

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const computedBeneficiaryLines = lines.map((line) => ({
        beneficiary_id: line.beneficiary_id.value,
        amount: line.amount,
        notes: line.notes || "",
      }));
      setDisplayMoyasar(true);
      dispatch(setMobile(sponsor.mobile));
      dispatch(setBeneficiaryLines(computedBeneficiaryLines));
      dispatch(setDonationTypeId({ name: "مبلغ إضافي" }));
      setIsModalVisible(false);
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    {
      title: "المستفيد",
      dataIndex: "beneficiary_id",
      width: 250,
      render: (_: any, __: any, index: number) => (
        <Form.Item
          name={`line_${lines[index].id}_beneficiary_id`}
          rules={[{ required: true, message: "الرجاء اختيار المستفيد" }]}
        >
          <Selects
            options={formattedOptions}
            selectPlaceholder="اختر مستفيد"
            value={lines[index]?.beneficiary_id}
            onChange={(value) =>
              handleInputChange(value, index, "beneficiary_id")
            }
          />
        </Form.Item>
      ),
    },
    {
      title: "المبلغ",
      dataIndex: "amount",
      width: 180,
      render: (_: string, __: any, index: number) => (
        <Form.Item
          name={`line_${lines[index].id}_amount`}
          rules={[
            { required: true, message: "الرجاء إدخال المبلغ" },
            {
              validator: (_, value) => {
                if (!value || parseFloat(value) >= 5) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("الحد الأدنى للمبلغ هو 5"));
              },
            },
          ]}
        >
          <div
            className="takaful--donation-input-with-prefix"
            style={{ height: "2.5rem " }}
          >
            <Inputs
              style={{
                fontSize: "1.2rem",
                border: "none",
                height: "100%",
                borderRadius: "0 7px 7px 0",
              }}
              type="tel"
              placeholder="أدخل المبلغ"
              value={lines[index]?.amount}
              onChange={(e) =>
                handleInputChange(e.target.value, index, "amount")
              }
            />
            <span className="takaful--donation-prefix icon-saudi_riyal"></span>
          </div>
        </Form.Item>
      ),
    },
    {
      title: "الملاحظات",
      dataIndex: "notes",
      render: (_: string, __: any, index: number) => (
        <Form.Item name={`line_${lines[index].id}_notes`}>
          <Input.TextArea
            style={{ height: "2.5rem" }}
            placeholder="أدخل الملاحظات (اختياري)"
            value={lines[index]?.notes}
            onChange={(e) => handleInputChange(e.target.value, index, "notes")}
          />
        </Form.Item>
      ),
    },
    {
      title: (
        <PrimaryButton
          title="إضافة مستفيد جديد"
          className="takaful--primary-button-info"
          icon={<PlusCircleOutlined />}
          onClick={addLine}
        />
      ),
      render: (_: any, __: any, index: number) =>
        lines.length > 1 && (
          <PrimaryButton
            style={{ marginBottom: "1.5rem" }}
            title=""
            icon={<DeleteOutlined />}
            onClick={() => removeLine(index)}
          />
        ),
    },
  ];

  return (
    <>
      <ModalComponent
        destroyOnClose={true}
        title=""
        open={isModalVisible}
        onClose={() => {
          setIsModalVisible(false);
          dispatch(resetMoyasar());
        }}
        closeOnOutsideClick={true}
        width={1050}
        modalStyle={{ top: 100 }}
      >
        <Form form={form} layout="vertical">
          <Row justify={"center"} style={{ paddingBottom: "2rem" }}>
            <p className="takaful--confirm-logout">
              التبرع بمبلغ إضافي للأيتام
            </p>
          </Row>
          <Row
            gutter={8}
            dir="rtl"
            style={{ marginTop: "2rem" }}
            className={`takaful--content-profile-box1 takaful--content-select`}
          >
            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
              <p className="takaful--content-services-request-p">
                نوع التبرع :
              </p>
            </Col>
            <Col xxl={19} xl={19} lg={19} md={19} sm={19} xs={19}>
              <PrimaryButton
                className="active-btn"
                title="مبلغ إضافي"
                style={{
                  paddingTop: "2rem",
                  width: "5rem",
                  marginLeft: "0.5rem",
                }}
              />
            </Col>
          </Row>
          <Table
            style={{ direction: "rtl", marginTop: "1rem" }}
            className="takaful--table"
            columns={columns}
            dataSource={lines}
            pagination={false}
            scroll={{ x: "max-content" }}
            rowKey="id"
            locale={{ emptyText: "لا يوجد بيانات" }}
          />

          <Row style={{ marginTop: "1rem" }}>
            <Col span={24} style={{ textAlign: "start" }}>
              <PrimaryButton title="تبرع" onClick={handleSubmit} />
            </Col>
          </Row>
        </Form>
      </ModalComponent>
      <MoyasarForm
        amount={totalAmount}
        description="Takaful"
        open={isMoyasarOpen}
        handleClose={() => {
          setDisplayMoyasar(false);
          dispatch(setBeneficiaryLines([]));
        }}
      />
    </>
  );
};

export default AddDonateToOrphansRequest;
